/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import Avatar from 'components/base/Avatar';
import { Card, Col, Row } from 'react-bootstrap';
import classNames from 'classnames';
import Badge from 'components/base/Badge';
import { formatDate, formatTimeToAmPm } from 'services/utils';

const EmployeeProfileCard = ({ className, data }) => {
  console.log('🚀 ~ EmployeeProfileCard ~ data:', data);
  const { first_name, employee_image, employee_role, status } =
    data?.personal_information || {};
  const { date_of_joining, designation_name } =
    data?.professional_details || {};
  return (
    <Card className={classNames(className)}>
      <Card.Body className="pt-3">
        <p className="text-600 fw-semi-bold fs-9 d-flex justify-content-between">
          <span>
            Joined on:{' '}
            <span className="text-700">
              {formatDate(date_of_joining, 'DD MMM YYYY') || '__/__/__'}
            </span>
            {/* value={`${Passport?.document_expiry_date ? formatDate(Passport?.document_expiry_date, 'DD MMM YYYY', false) : '--'}`} */}
          </span>
          {/* <Badge variant="phoenix" bg="success" className="pt-1">
            Present
          </Badge> */}
        </p>

        <Row className="align-items-center g-3 text-center text-xxl-start">
          <Col xs={12} xxl="auto">
            <Avatar
              size="5xl"
              alt={`${first_name} profile image`}
              src={employee_image || null}
              className="d-inline-block"
            />
          </Col>
          <Col xs={12} sm="auto" className="flex-1">
            <h3 className="fw-bolder mb-2">{first_name}</h3>
            <p className="mb-0">{designation_name || 'No Role Assigned yet'}</p>
            {status == 'Active' ? (
              <Badge variant="phoenix" bg="success">
                {status}
              </Badge>
            ) : (
              <Badge variant="phoenix" bg="warning">
                {status}
              </Badge>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default EmployeeProfileCard;
